import { render, staticRenderFns } from "./FlowBodyEditor.vue?vue&type=template&id=1522790a&"
import script from "./FlowBodyEditor.vue?vue&type=script&lang=ts&"
export * from "./FlowBodyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports